import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import { Chapter, FadeUp } from '../motion';
import { useT } from '../../i18n/LangContext';
import { useContent } from '../../data/useContent';

const SPANS = ['lg:col-span-7', 'lg:col-span-5', 'lg:col-span-5', 'lg:col-span-7', 'lg:col-span-12'];

export default function Services() {
  const t = useT();
  const { SERVICES } = useContent();

  return (
    <section data-testid="services-section" className="bg-white py-24 text-ink md:py-32">
      <div className="container-site">
        <Chapter n={1} label={t['ch.whatWePaint']} dark />
        <FadeUp>
          <h2 className="max-w-3xl font-serif text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
            {t['sv.h2a']} <span className="italic text-gold-dim">{t['sv.h2b']}</span>{t['sv.h2c']}
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-neutral-500">{t['sv.p']}</p>
        </FadeUp>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-12">
          {SERVICES.map((s, i) => (
            <FadeUp key={s.slug} delay={(i % 3) * 0.08} className={`md:col-span-1 ${SPANS[i] || 'lg:col-span-6'}`}>
              <article data-testid={`service-card-${s.slug}`}
                className="group relative flex h-full flex-col overflow-hidden rounded-xl border border-black/10 bg-white shadow-sm transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-2xl">
                <div className="relative h-56 overflow-hidden">
                  <img src={s.img} alt={`${s.name} — Reverence Services, Ottawa`} loading="lazy"
                    className="photo-treat h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink/50 to-transparent" />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="font-serif text-2xl font-semibold">{s.name}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-neutral-500">{s.tagline}</p>
                  <div className="mt-5 flex items-center gap-5">
                    <Link data-testid={`service-explore-${s.slug}`} to={`/${s.slug}`}
                      className="flex items-center gap-1.5 text-sm font-bold text-ink transition-colors hover:text-gold-dim">
                      {t['sv.explore']} <ArrowUpRight className="h-4 w-4" />
                    </Link>
                    <Link data-testid={`service-quote-${s.slug}`} to={`/quote?service=${encodeURIComponent(s.name)}`}
                      className="flex items-center gap-1.5 text-sm font-bold text-gold-dim transition-colors hover:text-gold">
                      {t['sv.getQuote']} <ArrowRight className="h-4 w-4" />
                    </Link>
                  </div>
                </div>
              </article>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
